import React, { ReactNode } from "react";
import { styled } from "@mui/material";
import { colors, fonts } from "@constants/cssVariables";

const Paragraph = styled("p")({
  font: fonts.bodyMedium,
  color: colors.neutral80,
});

const RichTextParagraph: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <Paragraph>{children}</Paragraph>;
};

export default RichTextParagraph;
